import React from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import { IconButton } from "@material-ui/core";

import Icon from "components/Icon";
import { useInventoryNavigation } from "contexts/InventoryNavigationContext";

const EditItemButton = ({ item }) => {
  const history = useHistory();
  const location = useLocation();
  const { saveFilters } = useInventoryNavigation();

  const handleEditClick = () => {
    const currentFilters = queryString.parse(location.search);
    saveFilters(currentFilters);
    history.push(`/inventory/items/edit/${item._id}`);
  };

  return (
    <IconButton onClick={handleEditClick}>
      <Icon
        name={"edit"}
        color={"black"}
        classnames={"item-table-action-icon"}
        fontSize={18}
      />
    </IconButton>
  );
};

EditItemButton.propTypes = {
  // TODO: handle shape of product
  item: PropTypes.object.isRequired,
};

export default EditItemButton;
